import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AuthService } from '../Services/auth.service';
import { Logininfo } from '../classes/Loginifo';

@Component({
  selector: 'app-register-password',
  templateUrl: './register-password.component.html',
  styleUrls: ['./register-password.component.css']
})
export class RegisterPasswordComponent implements OnInit {
  RegisterForm: FormGroup;
  user: string;
  message: string;

  constructor(
    private router: Router,
    private fb: FormBuilder,
    public authService: AuthService,
  ) { }

  ngOnInit() {
    this.RegisterForm = this.fb.group({
      password: ['', Validators.required],
      confirm: ['', Validators.required],
    });
    this.user = this.authService.getName();
  }

  Register() {
    if (this.RegisterForm.invalid) {
      return;
    } else {
      var password = this.RegisterForm.get('password').value;
      var confirm = this.RegisterForm.get('confirm').value;

      let reg = this.authService.register(password, confirm);

      reg.subscribe(res => {
        if (res == "success") {
          //トップ画面へ遷移
          this.router.navigate(['/top/']);
        }
        if (res == "Failed") {
          this.message = 'パスワードが間違っています';
        }
      });
    }
  }
}
